module.exports = __webpack_public_path__ + "img/Frame-81.78d94c48.svg";